import type {PosterLoadObject} from '@PosterWhiteboard/poster/poster.types';
import type {PageObject} from '@PosterWhiteboard/page/page.types';

export const getFirstPageObjectFromPosterObject = (posterObject: PosterLoadObject): PageObject | undefined => {
  const firstPageId = posterObject.pages.pageOrder[0];
  return firstPageId ? posterObject.pages.pagesHashMap[firstPageId] : undefined;
};

export const getFirstTemplateIdFromPosterObject = (posterObject: PosterLoadObject): string => {
  return getFirstPageObjectFromPosterObject(posterObject)?.templateData?.posterId ?? '';
};

export const getFirstGalleryTemplateIdFromPosterObject = (posterObject: PosterLoadObject): string | undefined => {
  return getFirstPageObjectFromPosterObject(posterObject)?.galleryTemplateData?.posterId;
};

export const getFirstGalleryTemplateCreatorIdFromPosterObject = (posterObject: PosterLoadObject): number => {
  return getFirstPageObjectFromPosterObject(posterObject)?.galleryTemplateData?.idGalleryTemplateCreator ?? 0;
};
